//
// @author  Agence Dn'D <contact@dnd.fr>
// @license https://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
// @link    https://www.dnd.fr/
//

$(document).ready(function () {
    /**
     * Initialize Slick carousel with custom configuration.
     * Ensures the gallery is only initialized once and applies lazyload fixes.
     *
     * @param {HTMLElement|jQuery} container - The container element for the gallery.
     */
    function initializeCustomSlick(container) {

        const $gallery = $('.custom-gallery', container);

        if ($gallery.length && !$gallery.hasClass('slick-initialized')) {
            const customSlickConfig = {
                autoplay: false,
                fade: false,
                infinite: false,
                swipeToSlide: true,
                slidesToScroll: 1,
                useTransform: true,
                arrows: true,
                dots: false,
                prevArrow: `<button type="button" class="image-page-button image-page-button--previous ltr-icon" aria-label="'${theme.strings.previous}">${theme.icons.chevronLeft}</button>`,
                nextArrow: `<button type="button" class="image-page-button image-page-button--next ltr-icon" aria-label="${theme.strings.next}">${theme.icons.chevronRight}</button>`,
                rtl: document.querySelector('html[dir=rtl]') ? true : false,

                slidesToShow: 9,

                responsive: [
                    {
                        breakpoint: 1300,
                        settings: { slidesToShow: 7.5 },
                    },
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 6.5 }
                    },
                    {
                        breakpoint: 768,
                        settings: { slidesToShow: 4.5 }
                    }
                ]
            };

            $gallery.on('init', function () {
                $('.lazyload--manual', this).removeClass('lazyload--manual').addClass('lazyload');
            }).slick(customSlickConfig);
        }
    }

    /**
     * Disable auto-submit behavior of the filter form.
     * This removes the 'change' event listener attached by the theme.
     *
     * @param {HTMLElement|jQuery} container - The container element where the filter form resides.
     */
    function disableFilterAutoSubmit(container) {
        const $containerElement = $(container);

        if ($containerElement.length) {
            $containerElement.off('change', '#CollectionFilterForm');
        }
    }

    /**
     * Debounce helper
     * @param {Function} callback
     * @param {number} waitMs
     * @returns {Function}
     */
    function debounce(callback, waitMs) {
        let timeoutId;

        return function debouncedFunction() {
            const context = this;
            const args = arguments;

            clearTimeout(timeoutId);

            timeoutId = setTimeout(function () {
                callback.apply(context, args);
            }, waitMs);
        };
    }

    /**
     * Update the filters submit button count dynamically by fetching the section HTML
     * with current query parameters, and extracting the count from the returned markup.
     *
     * @param {HTMLElement|jQuery} container
     */
    function initializeDynamicFiltersCount(container) {
        const $container = $(container);
        const $sectionRoot = $container.closest('[data-section-type="collection-template"]');
        const sectionId = $sectionRoot.data('filter-section-id') || $sectionRoot.data('section-id');
        const $form = $container.find('#CollectionFilterForm');
        const $count = $container.find('.filters__count');
        const $submitButton = $container.find('.filter-submit-row button[type="submit"]').first();

        if (!$form.length || !sectionId) {
            return;
        }

        const updateCount = debounce(function () {
            const searchParams = new URLSearchParams($form.serialize());
            searchParams.set('section_id', sectionId);

            const requestUrl = window.location.pathname + '?' + searchParams.toString();

            $.get(requestUrl)
                .done(function (html) {
                    const $html = $('<div>').append($.parseHTML(html));
                    const $incomingSection = $html.find('[data-section-id="' + sectionId + '"]');
                    let incomingText = '';

                    if ($incomingSection.length) {
                        // Replace entire submit button label if present
                        const $incomingSubmit = $incomingSection.find('.filter-submit-row button[type="submit"]').first();
                        if ($submitButton.length && $incomingSubmit.length) {
                            $submitButton.html($incomingSubmit.html());
                        }

                        // Also keep legacy behavior of updating count if needed
                        const $incomingCount = $incomingSection.find('.filters__count').first();
                        incomingText = $incomingCount.length ? $incomingCount.text() : '';
                    } else {
                        // Fallback: search globally in returned HTML
                        const $anyCount = $html.find('.filters__count').first();
                        incomingText = $anyCount.length ? $anyCount.text() : '';
                    }

                    if ($count.length && typeof incomingText === 'string') {
                        $count.text(incomingText);
                    }
                })
                .fail(function () {
                    // Silently ignore failures; keep previous count
                });
        }, 200);

        $container.on('change input', '#CollectionFilterForm input, #CollectionFilterForm select', updateCount);
    }

    /**
     * Main function to handle collection section logic.
     * Initializes the custom slick gallery and disables filter auto-submit after a short delay.
     *
     * @param {HTMLElement|jQuery} container - The container element for the collection section.
     */
    function handleCollectionSection(container) {
        initializeCustomSlick(container);

        setTimeout(function () {
            disableFilterAutoSubmit(container);
        }, 50);
        initializeDynamicFiltersCount(container);
    }

    /**
     * Run logic for collection sections already present on the page.
     */
    $('[data-section-type="collection-template"]').each(function () {
        handleCollectionSection(this);
    });

    /**
     * Run logic for collection sections loaded via AJAX (Shopify sections).
     */
    $(document).on('shopify:section:load', function (event) {
        const $container = $(event.target).find('[data-section-type="collection-template"]');

        if ($container.length) {
            handleCollectionSection($container);
        }
    });
});
